import { Component, Element, Listen, Prop, State, h } from '@stencil/core';
import { images } from '../../../../helpers/inline-images.service';
import { Menu } from '../../../navigation-structure.models';
import { getTranslatedLabel } from '../../language.util';

@Component({
    tag: 'pnl-navigation-main-menu',
})
export class NavigationMainMenu {
    @Element() component;

    @State() open = false;

    @Prop() locale: string;
    @Prop() menu: Menu;
    @Prop() renderedIndex: string;

    private canHover = window.matchMedia('(hover: hover)').matches;
    private windowWidth = window.innerWidth;

    @Listen('mouseenter')
    openMenu() {
        if (this.windowWidth > 912 && this.canHover) {
            this.open = true;
        }
    }

    @Listen('mouseleave')
    closeMenu() {
        if (this.windowWidth > 912 && this.canHover) {
            this.open = false;
        }
    }

    @Listen('keydown', { target: 'document' })
    closeMenuOnEscape(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            this.closeMenu();
        }
    }

    @Listen('focusout')
    focusOut(event: FocusEvent) {
        if (
            event.relatedTarget instanceof Node &&
            this.component.contains(event.relatedTarget)
        ) {
            return;
        }
        this.closeMenu();
    }

    toggleMenu() {
        this.open = !this.open;
    }

    render() {
        const shouldRender =
            this.menu.items.length > 0 || this.menu.quicklinks.length > 0;
        return (
            <div class="pnl-navigation__wrapper">
                <a class="pnl-navigation__link" href={this.menu.link}>
                    <span class="pnl-navigation__link-txt">
                        {this.menu.title}
                    </span>
                </a>
                {shouldRender && (
                    <button
                        type="button"
                        class="pnl-navigation__sub-toggle"
                        onClick={() => this.toggleMenu()}
                        aria-controls={
                            'pnl-navigation-sub-menu-container' +
                            this.renderedIndex
                        }
                        aria-expanded={this.open ? 'true' : 'false'}
                    >
                        <span innerHTML={images.arrow_up}></span>
                        <span class="visually-hidden">
                            {getTranslatedLabel(this.locale).subMenu}
                        </span>
                    </button>
                )}
                {shouldRender && (
                    <pnl-navigation-sub-menu
                        renderedIndex={this.renderedIndex}
                        menu={this.menu}
                        hidden={!this.open}
                    ></pnl-navigation-sub-menu>
                )}
            </div>
        );
    }
}
